import { Action } from './action';

export class MarkAsRead extends Action {
    constructor(public bookingId: string, public isUserLoggedIn: boolean, public contentIdentifier: string) {
        super();
    }
}
